import type { DecoBuildCtx } from "./define.ts";
import { shade, rand } from "../color.ts";

// A low leafy bush — a few overlapping green balls of foliage near the ground
// (rounded art style, plan 28 stage 4 — was overlapping boxes).
// Geometry only — spawn metadata (weight/mapColor/habitat/sway/…) lives in
// content/decos/bush.json; this build is registered in src/model/coded.ts.
const build: (ctx: DecoBuildCtx) => void = ({ ball, seed }) => {
    const base = shade(0x3f7a37, (rand(seed) - 0.5) * 0.3);
    const count = 2 + Math.floor(rand(seed + 1) * 2);
    for (let i = 0; i < count; i++) {
      const a = rand(seed + i * 5) * Math.PI * 2;
      const r = rand(seed + i * 5 + 1) * 0.6;
      const s = 0.9 + rand(seed + i * 5 + 2) * 0.6;
      // A softly squashed ball of leaves — depth ovalizes local z, and the
      // [π/2,0,0] tilt lands that squash on the world vertical so the clump
      // reads as a low mound rather than a perfect sphere.
      ball(
        Math.cos(a) * r,
        s * 0.45,
        Math.sin(a) * r,
        s * 0.55,
        shade(base, i * 0.08),
        0.85,
        [Math.PI / 2, 0, 0],
      );
    }
  };

export default build;
